export default __webpack_public_path__ + "static/media/illustration.8c99cad2.svg";